import { ColumnInterface } from "components/tables/interfaces";
import Table from "components/tables/table";
import { timestamp } from "lib/date";
import { ListInvitation } from "models/list-invitation";
import { FunctionComponent } from "react";
import { useTranslate } from "stores/hooks/translation";

interface InvitationsTableProps {
  listUuid: string;
  invitations: ListInvitation[];
}

const InvitationsTable: FunctionComponent<InvitationsTableProps> = ({
  listUuid,
  invitations,
}) => {
  const translate = useTranslate();

  const getEmailStatus = (invitation: ListInvitation) => {
    const { listInvitationEmail } = invitation;
    if (!listInvitationEmail) {
      return "n/a";
    }

    const { listInvitationEmailEvents = [] } = listInvitationEmail;
    const [firstEvent] = listInvitationEmailEvents;
    if (!firstEvent) {
      return "n/a"; // should this be "sent"
    }

    return translate(`email_event_type_${firstEvent.type}`);
  };

  const columns: ColumnInterface[] = [
    {
      key: "timestamp",
      header: "Lähetetty",
      width: 160,
      render: (invitation: ListInvitation) => timestamp(invitation.created_at),
    },
    {
      key: "to",
      header: "Vastaanottaja",
      width: 250,
      render: (invitation: ListInvitation) => {
        const { listInvitationEmail } = invitation;
        return listInvitationEmail ? listInvitationEmail.to : "";
      },
      search(invitation: ListInvitation, keyword, _column) {
        return invitation.listInvitationEmail.to
          .toLocaleLowerCase()
          .includes(keyword.toLocaleLowerCase());
      },
    },
    {
      key: "subject",
      header: "Otsikko",
      render: (invitation: ListInvitation) => {
        const { listInvitationEmail } = invitation;
        return listInvitationEmail ? listInvitationEmail.subject : "";
      },
    },
    {
      key: "status",
      header: "Tila",
      width: 200,
      render: (invitation: ListInvitation) => getEmailStatus(invitation),
    },
  ];

  return (
    <Table
      name={`list-${listUuid}-invitations`}
      columns={columns}
      data={invitations}
      search
      searchHint="Etsi sähköpostiosoitteella..."
    />
  );
};

export default InvitationsTable;
